import { Controller } from "@hotwired/stimulus";
import { leave } from "el-transition";

export default class extends Controller {
  static targets = ["hiddenField"];

  commence() {
    this.hiddenFieldTarget.value = "1";
    this.element
      .querySelectorAll("[required]")
      .forEach((field) => (field.required = false));

    leave(this.element);

    setTimeout(() => {
      this.element.style.display = "none";
    }, 250);
  }
}
